import React from "react";
import { useAlgorithmPresets, type AlgorithmPreset } from "../../../api/useAlgorithmPresets";
import useInput from "@ui/lib/hooks/useInput";
import t from "../../../i18n";
import Select from "@ui/Select";

const AlgorithmVersions = ({
  currentAlgorithmSetting,
  handleSettingAlgorithmVersion,
}: {
  currentAlgorithmSetting: AlgorithmPreset["key"];
  handleSettingAlgorithmVersion: (value: AlgorithmPreset["key"]) => void;
}) => {
  const algorithmVersions = useAlgorithmPresets();
  const { value: algoritmVersionValue } = useInput(
    algorithmVersions.find(f => f.key === currentAlgorithmSetting)?.key,
  );
  const versionOptions = algorithmVersions
    .map(version => ({
      label: version.translateKey,
      value: version.key,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
  return (
    <Select
      label={t("app.customization.algorithm.select.label")}
      value={algoritmVersionValue}
      onChange={e => handleSettingAlgorithmVersion(e.target.value)}
      prompt="version"
      clearable={false}
      options={versionOptions}
      tooltipOverlay={t("customization.algorithm.tooltip.text")}
    />
  );
};

export default AlgorithmVersions;
